import React, { useState } from 'react';
import { Modal, Button, Radio, TextArea, Icon } from 'semantic-ui-react';
import TextareaAutosize from 'react-textarea-autosize';
import PropTypes from 'prop-types';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import md5 from 'md5';
import Chance from 'chance';
import { useField } from '../../hooks';
import styles from './AnnouncementModal.module.scss';
import api from '../../api';
import '@wangeditor/editor/dist/css/style.css';
import { uploadFile } from '../../utils/cos';

function AnnouncementModal({ edit, onRenew, onClose }) {
  const isEdit = React.useMemo(() => Object.keys(edit).length > 0, [edit]);

  const [value, handleFieldChange] = useField(Object.keys(edit).length ? edit.title : '');
  const [radio, setRadio] = useState(isEdit ? edit.isRelease : false);
  const [popups, setPopups] = useState(isEdit ? edit.isPopups : false);
  const [editor, setEditor] = useState(null); // 存储 editor 实例
  const [html, setHtml] = useState(isEdit ? edit.describe : '');

  const handleRadioChange = () => {
    setRadio(!radio);
  };

  const handlePopupsChange = () => {
    setPopups(!popups);
  };
  const handleCreate = async () => {
    await api.createAnnouncement({
      describe: html,
      title: value,
      isRelease: radio,
      isPopups: popups,
    });
    onRenew();
    onClose();
  };
  const handleSave = async () => {
    await api.updateAnnouncement(edit.id, {
      describe: html,
      title: value,
      isRelease: radio,
      isPopups: popups,
    });
    onRenew();
    onClose();
  };

  React.useEffect(() => {
    if (editor) {
      editor.getMenuConfig('uploadImage').customUpload = async (file, insertFn) => {
        const dirname = md5(`${new Chance().string({ length: 6 })}`);
        const data = await uploadFile(`/attachments/${dirname}`, file);
        insertFn(`https://${data.Location}`, dirname, `https://${data.Location}`);
      };
      editor.getMenuConfig('uploadVideo').customUpload = async (res, insertFn) => {
        const dirname = md5(`${new Chance().string({ length: 6 })}`);
        const data = await uploadFile(`/attachments/${dirname}`, res);
        insertFn(`https://${data.Location}`, dirname, `https://${data.Location}`);
      };
    }
    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor]);

  return (
    <Modal
      open
      size="small"
      centered={false}
      onClose={onClose}
      closeOnDimmerClick={false}
    >
      <Modal.Header>{edit ? '编辑公告' : '新增公告'}</Modal.Header>
      <Modal.Content scrolling>
        <Icon
          name="close"
          style={{ cursor: 'pointer', position: 'absolute', right: '1rem', top: '1rem' }}
          onClick={!isEdit ? handleCreate : handleSave}
        />
        <TextArea
          as={TextareaAutosize}
          spellCheck={false}
          className={styles.field}
          value={value}
          onChange={handleFieldChange}
          placeholder="请输入公告标题"
        />
        <div style={{ border: '1px solid #ccc', zIndex: 100, marginTop: '15px' }}>
          <Toolbar editor={editor} mode="default" style={{ borderBottom: '1px solid #ccc' }} />
          <Editor
            defaultConfig={{ placeholder: '请输入内容...' }}
            value={html}
            onCreated={setEditor}
            onChange={(even) => setHtml(even.getHtml())}
            mode="default"
            style={{ height: '500px' }}
          />
        </div>
        <div style={{ margin: '20px 0' }}>
          <Radio label="是否发布" toggle checked={radio} onChange={handleRadioChange} />
        </div>
        <div>
          <Radio label="是否弹窗" toggle checked={popups} onChange={handlePopupsChange} />
        </div>
      </Modal.Content>
      <Modal.Actions>
        {!isEdit ? (
          <Button primary onClick={handleCreate}>
            新增
          </Button>
        ) : (
          <Button primary onClick={handleSave}>
            保存
          </Button>
        )}

        <Button onClick={onClose}>取消</Button>
      </Modal.Actions>
    </Modal>
  );
}
AnnouncementModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  edit: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onRenew: PropTypes.func.isRequired,
};

AnnouncementModal.defaultProps = {
  edit: {},
};

export default AnnouncementModal;
